
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./courseCard.css";

const CourseCard = ({
  details,
  forwordicon,
  award,
  getButtonText,
  roundRatio,
  convertMinutesToHours,
  getexpertsbysubject,
  gotocoursesoutline,
  setState,
  isGreen,
}) => {
  if (!details) return null;

  const handleCardClick = () => {
    setState(details.courseKit);
    gotocoursesoutline(
      details.mySubject[0],
      details.courseName,
      details._id,
      details.courseName,
      details.accept_badge_url,
      details.totalCourseTime,
      details.courseDescription,
      details.courseOneLiner,
      details.courseSession,
      details.completionRatio,
    );
  };

  const isCompleted = (ratio) => {
    if (!ratio) return false;
    const [done, total] = ratio.split("/");
    return Number(done) === Number(total);
  };
  console.log("course details in card", details);

  return (
    <div
      onClick={handleCardClick}
      className={`border rounded-lg p-4 flex flex-col justify-between transition
    ${isGreen ? "bg-[#E5ECE3] border-[#2E7D32]" : "bg-white hover:shadow-md"}
  `}
    >
      <div className="flex justify-between mb-1 items-start">
        {/* LEFT */}
        <div className="flex-1">
          <h3 className="ctitle text-base mb-1">{details.courseName}</h3>
          <p className="text-gray-600 text-sm">
            {/* {details.courseDescription.length > 100
              ? details.courseDescription.split(" ").slice(0, 5).join(" ") + "..."
              : details.courseDescription} */}
            {details.courseOneLiner.split(" ").slice(0, 5).join(" ") +
              (details.courseOneLiner.split(" ").length > 5 ? "..." : "")}
          </p>
        </div>

        {/* RIGHT */}
        <div className="flex flex-col items-end self-start">
          {/* <span className="text-xs text-gray-800 font-medium mb-1 w-6">
            {details.accept_badge_url !== "" ? (
              <img className="h-6 w-6" src={award} alt="award" />
            ) : (
              <CircularProgressbar
                strokeWidth={15}
                maxValue={100}
                value={roundRatio(details.completionRatio)}
                styles={buildStyles({ pathColor: "#005230" })}
              />
            )}
          </span> */}
          <span className="text-xs text-gray-800 font-medium mb-1 w-6">
            {isCompleted(details.completionRatio) ? (
              <img className="h-6 w-6" src={award} alt="award" />
            ) : (
              <CircularProgressbar
                strokeWidth={15}
                maxValue={100}
                value={roundRatio(details.completionRatio)}
                styles={buildStyles({ pathColor: "#005230" })}
              />
            )}
          </span>
          <p className="cpara text-nowrap m-0">
            {convertMinutesToHours(details.totalCourseTime)}
          </p>
        </div>
      </div>

      <div className="flex justify-between gap-2 items-end mt-2">
        {/* Subject Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            getexpertsbysubject(details?.mySubject);
          }}
          className="Couursesubject-button"
        >
          <span className="subject-text">
            {details.mySubject[0] || "No Subject"}
          </span>
          <img className="subject-icon" src={forwordicon} alt="arrow" />
        </button>

        {/* Book Now Button */}
        <div
          className="startCourse-button online-booknow"
          disabled={!details.onlineOffline}
        >
          {getButtonText(details.completionRatio)}
        </div>
      </div>
    </div>
  );
};

export default CourseCard;

// {details.accept_badge_url !== '' ? (
//               <img className='h-6 w-6' src={award} alt='award' />
//             ) : (
//               <CircularProgressbar
//                 strokeWidth={15}
//                 maxValue={100}
//                 value={roundRatio(details.completionRatio)}
//                 styles={buildStyles({ pathColor: '#005230' })}
//               />
//             )}
